import NProgress from "nprogress"

export default async function openWindowAsync(callback: () => Promise<string>) {
  try {
    NProgress.start()

    const href = await callback()

    const aTag = document.createElement('a')
    aTag.rel = 'noopener'
    aTag.target = "_blank"
    aTag.href = href
    aTag.click()
    aTag.remove()
  } catch (error) {
    console.error(error)
    // TODO: Add a snackbar message.
  } finally {
    NProgress.done()
  }
}
